import RateModel from './rate.m';
import parser from '../parsers/business.m.p';

export default class extends RateModel {
    static parsers = {
        read: parser
    };
}
